<template>
  <div id="tab-user" v-if="tabs">
    <tab-vertical-component :tabs="tabs" v-if="tipe_project == 1" />
    <keyword-kabayan v-else />
  </div>
</template>

<script>
import keyword_kabayan from "@/views/pages/settings/KeywordKabayan.vue";
import tab_vertical from "@/views/components/tab_vertical.vue";
import tab_media_konvensional from "@/views/components/settings/keyword/tab_media_konvensional.vue";
import tab_media_sosial from "@/views/components/settings/keyword/tab_media_sosial.vue";
import tab_facebook_fanpage from "@/views/components/settings/keyword/tab_facebook_fanpage.vue";
import tab_instagram_hashtag from "@/views/components/settings/keyword/tab_instagram_hashtag.vue";
import tab_review_aplikasi from "@/views/components/settings/keyword/tab_review_aplikasi.vue";
import tab_impor_ekspor from "@/views/components/settings/keyword/tab_impor_ekspor.vue";
import tab_pemberitahuan_integrasi from "@/views/components/settings/keyword/tab_pemberitahuan_integrasi.vue";

export default {
  name: "tab_keyword",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "tab-vertical-component": tab_vertical,
    "keyword-kabayan": keyword_kabayan,
  },
  data() {
    return {
      tipe_project: this.data["tipe"],
      tabs: null,
    };
  },
  created: function () {
    let data = [];
    data["tipe_project"] = this.tipe_project;
    var tabs = [
      {
        name: "Media Konvensional",
        icon_class: "bi bi-globe-americas",
        component: tab_media_konvensional,
        data: data,
      },
      {
        name: "Media Sosial",
        icon_class: "bi bi-heart-fill",
        component: tab_media_sosial,
        data: data,
      },
      {
        name: "Facebook Fanpage",
        icon_class: "bi bi-facebook",
        component: tab_facebook_fanpage,
        data: data,
      },
      {
        name: "Instagram Hashtag",
        icon_class: "bi bi-globe-americas",
        component: tab_instagram_hashtag,
        data: data,
      },
      {
        name: "Review Aplikasi",
        icon_class: "bi bi-phone",
        component: tab_review_aplikasi,
        data: data,
      },
      {
        name: "Impor/Ekspor",
        icon_class: "bi bi-file-earmark-arrow-down",
        component: tab_impor_ekspor,
        data: data,
      },
      {
        name: "Pemberitahuan dan Integrasi",
        icon_class: "bi bi-globe-americas",
        component: tab_pemberitahuan_integrasi,
        data: data,
      },
    ];
    this.tabs = tabs;
  },
};
</script>